module.exports = __webpack_public_path__ + "img/CIO200_R.b5f8a480.png";